<script lang="ts" setup>
import { Badge } from '~ds/components/ui/badge';
import { Icon } from '~ds/components/ui/icon';
import { ICONS } from '~ds/lib/icons';
import { useI18n } from 'vue-i18n';

interface Props {
  hasCompletedAccount: boolean;
}
defineProps<Props>();

defineEmits<{
  verifyProfile: [];
}>();

const { t } = useI18n();
</script>

<template>
  <div class="w-full flex items-center">
    <Badge
      v-if="hasCompletedAccount"
      class="w-full py-2"
      variant="outline"
      tone="lime"
    >
      <Icon
        :name="ICONS.checkmarkCircle"
        size="sm"
        class="shrink-0"
      />
      {{ t('unified.activity.overview.prize.tagEntryConfirmed') }}
    </Badge>
    <KUICoreClickable
      v-else
      :aria-label="t('unified.activity.overview.prize.tagMissingVerification')"
      class="w-full"
      @click="$emit('verifyProfile')"
    >
      <Badge
        class="w-full py-2"
        variant="outline"
        tone="orange"
      >
        <Icon
          :name="ICONS.alertCircle"
          size="sm"
          class="shrink-0"
        />
        {{ t('unified.activity.overview.prize.tagMissingVerification') }}
      </Badge>
    </KUICoreClickable>
  </div>
</template>
